import './LinkMember.scss';
import { autobind } from 'office-ui-fabric-react/lib/Utilities';
import { Callout, DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { Persona, PersonaInitialsColor, PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import * as React from 'react';

export interface ILinkMemberProps {
    primaryText: string;
    imageUrl: string;
}

export interface ILinkMemberState {
    isCalloutVisible: boolean;
}

export class LinkMember extends React.Component<ILinkMemberProps, ILinkMemberState> {
    private _uniqueId: string; /* For the component, not the link member it represents. */

    constructor(props: ILinkMemberProps, context: any) {
        super(props);

        this.state = {
            isCalloutVisible: false
        };

        this._uniqueId = `j${Math.random().toString().replace('.', '')}`;
    }

    public render() {
        const props = this.props;
        const state = this.state;

        return (
            <div className='od-LinkMember'>
                <Persona
                    className='od-LinkMember-Persona'
                    primaryText={ props.primaryText }
                    initialsColor={ PersonaInitialsColor.blue }
                    size={ PersonaSize.extraExtraSmall }
                    onMouseOver={ this._onShowCallout }
                    onMouseLeave={ this._onDismissCallout }
                    id={ this._uniqueId }
                    imageUrl={ props.imageUrl }
                />
                { state.isCalloutVisible && (
                    <Callout
                        directionalHint={ DirectionalHint.topCenter }
                        onDismiss={ this._onDismissCallout }
                        target={ `#${this._uniqueId} ` }
                        setInitialFocus={ true }
                    >
                        <div className='od-LinkMember-tooltip'>
                            <span>{ props.primaryText }</span>
                        </div>
                    </Callout>
                ) }
            </div>
        );
    }

    @autobind
    private _onShowCallout() {
        this.setState({
            ...this.state,
            isCalloutVisible: true
        });
    }

    @autobind
    private _onDismissCallout() {
        this.setState({
            ...this.state,
            isCalloutVisible: false
        });
    }
}